/**
 * @Description 商圈不合适标记弹窗
 */
import { FC, useContext } from 'react';
import { Form, Modal } from 'antd';
import { useMethods } from '@lhb/hook';
import { useBigdataFn } from '@/common/utils/bigdata';
import { CollectListContext } from '@/views/youth/pages/map/ts-config';
import { markClusterUnsuitable } from '@/common/api/youth';
import V2Form from '@/common/components/Form/V2Form';
import V2FormTextArea from '@/common/components/Form/V2FormTextArea/V2FormTextArea';

interface AreaMarkingModalProps {
  modalData: {
    open: boolean; // 弹窗是否打开
    data: {
      modelClusterId: number | null; // 商圈ID
      [p: string]: any;
    };
  };
  onClose: () => void; // 关闭弹窗回调
  onSuccess?: () => void; // 标记成功回调
}

const AreaMarkingModal: FC<AreaMarkingModalProps> = ({
  modalData,
  onClose,
  onSuccess,
}) => {
  const [form] = Form.useForm();
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook

  const { open, data } = modalData;
  const { setUnsuitableMarkMap }: any = useContext(CollectListContext) || {};

  const methods = useMethods({
    /** 提交标记不合适表单 */
    handleSubmit() {
      form.validateFields().then((res: any) => {
        const { reason } = res || {};
        markClusterUnsuitable({
          modelClusterId: data.modelClusterId,
          reason,
        }).then((res: any) => {
          form.resetFields();
          bigdataFn('121824de-808b-4df6-affa-871df3a932fe', '商圈不合适标记', '标记不合适', { op_block: '商圈不合适标记', op_event: `商圈名称：${data?.areaName || data.modelClusterId}，不合适理由：${reason}`, });
          // 更新Context中的标记状态
          setUnsuitableMarkMap?.((prev: Record<number, any>) => ({
            ...prev,
            [data.modelClusterId!]: res,
          }));
          onClose();
          onSuccess?.();
        });
      });
    },
    /** 关闭弹窗 */
    handleCancel() {
      form.resetFields();
      onClose();
    },
  });

  return (
    <Modal
      title='不合适原因'
      open={open}
      onCancel={methods.handleCancel}
      onOk={methods.handleSubmit}
      maskClosable={false}
      destroyOnClose
      width={360}
    >
      <V2Form form={form}>
        <V2FormTextArea
          label=''
          name='reason'
          required
          placeholder='请输入不合适原因，最多200字'
          maxLength={200}
          config={{ showCount: true }}
        />
      </V2Form>
    </Modal>
  );
};

export default AreaMarkingModal;
